import { observer } from "mobx-react";
import { menuItems } from "modules/root/components/menu/MainMenu";
import React, { useEffect } from "react";
import { OrgTreeView } from "../org-tree/components/OrgTreeView";
import styles from "./DepartmentsPage.module.scss";

const menu = menuItems();

interface DepartmentsPageProps {
    access: string[];
    baseUrl: string;
}

/**
 * «Структура организации» — дерево подразделений. Справочники «Должности» и «Типы узлов»
 * и импорт из 1С — кнопками в шапке дерева. Должность — «кем работает», в дерево не входит,
 * подразделение сотрудника задаётся отдельно (ТЗ «Структура организации», 07.09.2026).
 */
export const DepartmentsPage = observer((_: DepartmentsPageProps) => {
    useEffect(() => {
        document.title = menu.spending.nested.departments.label;
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.tree}>
                <OrgTreeView />
            </div>
        </div>
    );
});
